export default {
  message: {
    "error": "おっと！何かがうまくいきませんでした。",
    "Sorrysomeerrorsoccurred": "予期しないエラーが発生しました。言語を切り替えるか、アプリを終了して再起動してみてください。",
    "quit": "終了",
    "language": "言語",
    "Youcanchangethelanguagehere": "ここで言語を変更できます！",
    "current": "現在の",
    "home": "ホーム",
    "friends": "友達",
    "wallet": "ウォレット",
    "aboutus": "私たちについて",
    "Sharewithfriends": "友達と共有",
    "copyFailure": "コピー失敗",
    "copySuccess": "コピー成功",
    "Claimreward": "報酬を受け取る",
    "DailyLogin": "毎日のログイン",
    "noInvitationsYet": "まだ招待はありません",
    "LoadMore": "もっと読み込む",
    "WatchAD": "広告を見る",
    "continue": "続行",
    "Congratulations": "おめでとうございます",
    "MyFriends": "私の友達",
    "Invitefriends": "友達を招待",
    "Invitepremiumfriends": "プレミアム友達を招待",
    "DailyTasks": "日常タスク",
    "inviteDesc": "招待する友達ごとに+{num} ${name}",
    "DailyTasksDesc": "タスクを完了してエアドロップを獲得しよう",
    "SponsorsandPartners": "スポンサーとパートナー",
    "Receivingwallet": "受取ウォレット",
    "Enterwalletaddress": "{name} のウォレットアドレスを入力",
    "Claim": "報酬を受け取る",
    "Booster": "ブースター",
    "RentPeriod": "レンタル期間",
    "days30": "30日間",
    "Dailyprofit": "毎日の利益",
    "Totalprofit": "総利益",
    "Quantity": "数量",
    "RentPrice": "レンタル価格",
    "RentMiner": "マイナーをレンタル",
    "Insufficient": "招待者が不十分です",
    "InsufficientMsg": "もっと多くのアクセサリーを得るためには、{num}人の友達を招待する必要があります。",
    "Settings": "設定",
    "copyid": "IDをコピー",
    "UpgradeSuccessfully": "アップグレード成功",
    "Name": "名前",
    "userinfo": "ユーザー情報",
    "disconnect": "切断",
    "Startmining": "マイニングを開始",
    "Welcome": "ようこそ {name} へ",
    "Withdrawal": "出金",
    "Minimumamount": "最小金額",
    "Networkfee": "ネットワーク手数料",
    "Enteramount": "金額を入力",
    "Submit": "提出",
    "MinimumTip": "引き出し金額が小さすぎます。最低引き出し金額: {num}",
    "MaximumTip": "金額が不足しています。最大引き出し金額は: {num}です。",
    "SubmittedTip": "提出されました。30～60営業日以内に処理される予定です。",
    "WebSubmittedTip": "提出されました。できるだけ早く処理します。",
    "WithdrawStatus": "ステータス",
    "Submissiontime": "提出時間",
    "WithdrawAwaitTip": "* 処理には30～60営業日かかると見込まれています。友達をもっと招待すると、審査プロセスが早くなります。",
    "WebWithdrawAwaitTip": "* 処理には24～48時間かかると見込まれています。友達をもっと招待すると、審査プロセスが早くなります。",
    "Processing": "処理中",
    "Success": "成功",
    "Rejection": "拒否",
    "Amount": "金額",
    "Numberoffriends": "友達の数: {now}/{limit}",
    "InviteTip": "最初の引き出しを行うには、{limit}人の友達をマイニングアプリに招待する必要があります。",
    "openonphone": "このリンクを携帯電話で開いてください。",
    "claimTip": "受け取るべき金額が小さすぎます。最低受け取り金額は: {num}です。",
    "WalletBalance": "ウォレット残高",
    "Withdraw": "引き出す",
    "SetWalletAddress": "ウォレットアドレスを設定",
    "WithdrawalRecord": "引き出し記録",
    "Norecords": "記録はありません",
    "Whatis": "{name}とは何ですか？",
    "All": "すべて",
    "save": "保存",
    "successWithdrawal": "スキャン成功 {num}",
    "secondsago": "{time}秒前",
    "Loading": "読み込み中...",
    "PaymentConfirming": "取引ステータスを確認中...",
    "Check": "確認",
    "CheckFail": "取引が完了していません。5秒後にもう一度確認してください。",
    "Addname": "'{name}'を名前に追加",
    "Restattcheck": "アプリを再起動して確認",
    "Copyname": "'{name}'をコピー",
    "SubmissionFailed": "提出に失敗しました。後でもう一度お試しください。",
    "WithdrawalReview": "引き出し審査",
    "select_payment_method": "支払い方法を選択",
    "total_amount": "合計金額",
    "next_step": "次のステップ",
    "creating_order": "注文を作成中...",
    "order_created": "注文が作成されました",
    "order_status": "注文ステータス",
    "order_id": "注文ID",
    "order_amount": "注文金額",
    "order_status_desc": "注文ステータスの説明",
    "payment_cancelled": "支払いがキャンセルされました",
    "opening_payment": "支払いを開いています...",
    "payment_success": "支払い成功",
    "payment_failed": "支払い失敗",
    "payment_pending": "支払い保留中",
    "payment_processing": "支払い処理中",
    "create_order_failed": "注文作成失敗",
    "creating_ton_order": "TON注文作成中...",
    "check_payment_status": "支払い状況を確認しています...",
    "use_ton_payment": "TON支払いを使用",
    "connect_wallet": "ウォレットを接続",
    "start_transaction": "取引を開始",
    "address": "住所",
    "amount_ton": "金額 TON",
    "copy": "コピー",
    "comment_memo": "コメントメモ",
    "comment_memo_desc": "コメントメモを入力してください",
    "comment_memo_placeholder": "コメントメモを入力",
    "amount": "金額",
    "wallet_address": "ウォレットアドレス",
    "you_can_choose_to_connect_wallet_to_pay": "支払いのためにウォレットを接続することができます",
    "or_manually_transfer_to_the_above_address": "または上記のアドレスに手動で送金してください（金額とメモは完全に一致する必要があります）",
    "transaction_success": "取引成功",
    "transaction_failed": "取引失敗",
    "transaction_error": "取引エラー",
    "transaction_status": "取引状況",
    "transaction_id": "取引ID",
    "transaction_amount": "取引金額",
    "transaction_status_desc": "取引状況の説明",
    "miner_detail": "マイナーの詳細",
    "rent_period": "レンタル期間",
    "days": "{days} 日",
    "daily_yield": "日次利回り",
    "total_yield": "総利回り",
    "invite_friends": "友達を招待",
    "price": "価格",
    "rent": "レンタル",
    "free_claim": "無料報酬受取",
    "redeem": "引き換え",
    "buy": "レンタル",
    "invite_friends_not_enough": "友達招待が足りません",
    "redeem_success": "引き換え成功",
    "redeem_failed": "引き換え失敗",
    "rent_success": "レンタル成功",
    "rent_failed": "レンタル失敗",
    "TotalPower": "総パワー",
    "MaxQuantity": "最大値に達しました",
    "Running": "実行中",
    "Stop": "停止",
    "Withdrawalunlock": "出金解除",
    "Close": "閉じる",
    "Delivering": "配信中",
    "Duetothelargenumber": "受取人が多いため、エアドロップは15〜20営業日内に到着する見込みです",
    "WithdrawalunlockTip": "出金を解除するには、{num}人の招待した友達が必要です",
    "mining_title": "ロボット",
    "Upgrade": "アップグレード",
    "partner": "パートナー",
    "faq": "よくある質問",
    "task": "タスク",
    "OpenRobot": "ロボットを開く",
    "MyRobot": "私のロボット",
    "Level": "レベル",
    "Commission": "コミッション",
    "DirectFriends": "直接友達",
    "Feedback": "フィードバック",
    "Pleaseenteryouremailaddress": "メールアドレスを入力してください",
    "Inputfeedbackcontent": "フィードバック内容を入力",
    "Submitfeedback": "フィードバックを送信",
    "Feedbacksubmittedsuccessfully,thankyouforyourvaluablefeedback": "フィードバックが正常に送信されました。貴重なフィードバックありがとうございます",
    "Feedbacksubmissionfailed,pleaseretriy": "フィードバックの送信に失敗しました。もう一度お試しください",
    "Addressformaterror": "アドレス形式エラー",
    "Readclipboardfailed": "クリップボードの読み取りに失敗しました",
    "Youhavealreadyfeedbackedtoday,pleasecomebacktomorrow": "今日はすでにフィードバック済みです。明日また来てください",
    "Record": "記録",
    "Newuserguidance": "ようこそツアーを見る",
    "Usetonwallet": "TONウォレットを使用",
    "Reward": "報酬",
    "Connectwallet": "ウォレットを接続",
    "Notconnected": "接続されていません",
    "Disconnect": "切断",
    "AboutTAI": "トークンの詳細",
    "WithdrawalRecordDesc": "引き出し記録",
    "StartAItrading": "AIトレーディングを開始",
    "Next": "次へ",
    "Start": "開始",
    "WithdrawalSuccess": "引き出し成功",
    "WithdrawalFail": "引き出し失敗",
    "Max": "最大",
    "WithdrawalRecords": "引き出し記録",
    "Commissionrules": "コミッションルール",
    "Mycommission": "私のコミッション",
    "Shop": "ショップ",
    "BuyDifferentAIrobots": "コンピュータデバイスをアップグレードして、スキャンをさらに高速化しましょう！",
    "CurrentRunningAIrobots": "現在稼働中のAIロボット",
    "DailyProfit": "日々の利益",
    "Buy": "購入",
    "ValidityPeriod": "有効期限",
    "Days": "日",
    "Price": "価格",
    "APY": "APY",
    "NoRobot": "コンピュートパワーなし",
    "RemainingTime": "残り時間",
    "InviteandEarn": "招待して報酬を得よう",
    "InvitDec": "友達を招待してAI取引に参加し、一緒にUSDTコミッションとエアドロップトークンを獲得しよう！",
    "ShareToGroups": "グループへ共有",
    "Select_payment_method": "支払い方法を選択してください",
    "twa_pay_tip_with_memo": "送金のために、アドレス、金額、およびメモが一致していることを確認してください。",
    "twa_pay_tip": "送金のために、アドレスと金額が正しいことを確認してください。",
    "twa_pay_tip_placeholder": "コメントメモを入力",
    "twa_pay_tip_placeholder_with_memo": "メモ付きのコメントメモを入力",
    "twa_pay_tip_placeholder_without_memo": "メモなしのコメントメモを入力",
    "twa_pay_tip_placeholder_with_memo_placeholder": "メモ付きのコメントメモを入力",
    "twa_pay_tip_placeholder_without_memo_placeholder": "メモなしのコメントメモを入力",
    "realtime_ai": "リアルタイムAIトレーディング",
    "check_transaction_status": "取引状況を確認",
    "transaction_wait": "取引処理中です。アプリを終了しても構いません。完了したらメッセージで通知されます。",
    "Pleaseenteravalidemailaddress": "有効なメールアドレスを入力してください",
    "max_robot_tip": "購入制限に達しました — 取引を続けるために別のプランを試してください！",
    "connectFailure": "ウォレットの接続に失敗しました",
    "connectSuccess": "ウォレットの接続に成功しました",
    "PayNow": "今すぐ支払う",
    "min_withdrawal_amount": "最低引き出し額は {num} {coin_name} です",
    "max_withdrawal_amount": "最大引き出し額は {num} {coin_name} です",
    "balance_not_enough": "この引き出しのための残高が不足しています。",
    "Numberofgroups": "グループ数: {now}/{limit}",
    "Withdraw_success": "引き出しに成功しました",
    "allProfit": "総利益",
    "AnnualProfit": "年間利益",
    "ScanWallet": "ウォレットをスキャン",
    "wallet_check": "wallet_check",
    "Found": "見つかりました",
    "ScanSpeed": "スキャン速度",
    "MyComputingPower": "コンピュート",
    "Scanning": "スキャン中！",
    "WithdrawDetail": "引き出しの詳細",
    "ScanSuccess": "スキャン成功率が上がりました！",
    "TaskDescription": "タスクを完了してスキャン成功率を上げましょう！",
    "InitializingMiningSystem": "スキャンシステムを初期化中...",
    "NoWithdrawalRecord": "出金履歴はありません",
    "Invite": "必要な招待数",
    "Free": "無料",
    "Confirm": "確認",
    "RefreshTasks": "タスクを更新",
    "NumberofGroups": "グループ数: {now}/{limit}",
    "SendMessage": "メッセージを送る",
    "NumberofShares": "シェア数: {now}/{limit}",
    "NumberofTasks": "タスク数: {now}/{limit}",
    "CompleteTask": "タスクを完了する",
    "Accelerated": "加速された",
    "Accelerated_withdrawals_success": "加速された引き出しが成功しました",
    "GoBuy": "購入する",
    "SpeedUpScan": "スピードアップ",
    "Earnings": "収益",
    "learnMore": "詳しく見る",
    "claimSuccess": "報酬を受け取りました",
    "claimFailed": "報酬の受け取りに失敗しました。再試行してください",
    "noDividends": "受け取る配当はありません",
    "dividendsInfoFallback": "友達を招待して紹介報酬を得よう"
}};